module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":"Workspace Setting","tab":{"overview":"Overview","member":"Members","delete":"Delete Workspace"}},"th":{"header":"ภาพรวมพื้นที่การทำงาน","tab":{"overview":"ภาพรวม","member":"สมาชิก","delete":"ลบเวิร์คสเปซ"}}}')
  delete Component.options._Ctor
}
